import useRequisitionResultPDFFragment from './useRequisitionPDFFragment.hook';

export default useRequisitionResultPDFFragment;
